export default function imei(imei: string) {
  return imei.substring(0, imei.length - 2)
}